import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import Chatbot from "../Chatbot";
import { Toaster } from "sonner";

export default function PublicLayout({ children }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
      <Chatbot />
      <Toaster position="top-right" richColors />
    </div>
  );
}
